export default class ResetPasswordDto {
	public userId = '';
	public resetToken = '';

	public constructor(init?: Partial<ResetPasswordDto>) {
        Object.assign(this, init);
    }
}